<ng-container *ngTemplateOutlet="optionTemplate ?? defaultTemplate; context: { $implicit: option }" />

<ng-template #defaultTemplate let-option>
  <div
    class="pointer mb-2 p-2 text-center"
    [class.pointer-events-none]="disabled"
    [ngClass]="{
      border: selected,
      'text-blue-100': !disabled,
      'text-steel-60': disabled,
      'border-steel-40': disabled,
      'border-blue-100': !disabled && selected,
      'border-blue-50': !disabled && !selected,
      'bg-steel-20': disabled,
      'bg-highlight-blue': !disabled && selected,
      'bg-blue-10': !disabled && !selected
    }">
    {{ option.label }}
  </div>
</ng-template>
